<script setup lang="ts">
import useExtraScript from '@composable/useExtraScript';

const { isMrbilit } = useWhiteLabel();
useExtraScript();
</script>

<template>
    <div>
        <slot />
        <VitePwaManifest v-if="isMrbilit" />
    </div>
</template>
